import { createEntityAdapter } from '@reduxjs/toolkit';

import type { SVGAPIData } from './svgs.types';

const svgAdapter = createEntityAdapter<SVGAPIData>({
  selectId: (svgData) => svgData.uid,
});

export default svgAdapter;
